import SettingsLayout from './SettingsLayout';

function SettingsSecurityPage() {
  return (
    <SettingsLayout>
      <div className="card">
        <div className="card-header">Security</div>
        <p style={{ color: '#4B5563', fontSize: '1rem', marginBottom: '1.5rem' }}>
          Manage your security settings and account safety.
        </p>
        <div style={{ padding: '2rem', backgroundColor: 'var(--color-light-grey)', borderRadius: '0.5rem', textAlign: 'center' }}>
          <p style={{ color: '#999' }}>Security features coming soon</p>
        </div>
      </div>
    </SettingsLayout>
  );
}

export default SettingsSecurityPage;
